import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { Remove, Add } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import colors from '../CustomizedUIs/Colors';
import ExpandButton from '../CustomizedUIs/ExpandButton';

const useStyles = makeStyles(theme => ({
    header: {
        paddingTop: 13,
        paddingBottom: 13,
    },
    headerOpenText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#fafefe',
    },
    headerClosedText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    }, borderEnity: {
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: theme.palette.primary.main,
    },
    borderEnityOpen: {
        borderRadius: ' 10px',
        boxShadow: '0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    borderRemove: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
    },
    borderAdd: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: '#e5f1f8',
    },
}));


export default function SubItem({ subColor, children, name, handleClick, open }) {
    const theme = useTheme()
    const classes = useStyles();

    const listItemClasses = open ? classes.headerOpenText : classes.headerClosedText
    return (
        <Box borderRadius='10px' className={!open ? classes.borderEnityOpen : classes.borderEnity} my={2}>
            <Box style={{ cursor: 'pointer' }} display='flex' width='100%'>
                <Box width='10px' bgcolor={open ? '#ffffff' : theme.palette.secondary.main} style={{ opacity: open ? 0.2 : 1, borderTopLeftRadius: '10px', borderBottomLeftRadius: open ? 0 : '10px' }}></Box>
                <ListItem onClick={handleClick} className={classes.header}>
                    {
                        typeof name === 'string' ?
                            <ListItemText primary={<Typography className={listItemClasses}>{name}</Typography>} />
                            :
                            (
                                { name }
                            )
                    }
                    <ExpandButton open={open} color={theme.squareButon.content} />
                </ListItem>
            </Box>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box display='flex'>
                    <Box width='4px' bgcolor={theme.palette.secondary.main} style={{ borderBottomLeftRadius: 10 }}></Box>
                    <Box bgcolor='background.paper' width='100%' style={{ borderBottomRightRadius: 10 }}>
                        <List component="div" disablePadding>
                            {children}
                        </List>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
}
